/**
 * Hook to measure browser window width in order to drive responsive layout
 * for regional standards display.
 */
import throttle from "lodash.throttle";
import * as React from "react";

const DESKTOP_WIDTH = 768;

// TODO(michaelpolyak): These should be using the "small", "medium", "large"
// terminology as per ADR #549. However, as we're using 768px breakpoint and
// not 682px as the ADR specifies, we'll first need to change our breakpoint
// width before updating the terminology. This may require revisiting design.
type Layout = "desktop" | "mobile";

function useResponsiveLayout(): Layout {
    const [windowWidth, setWindowWidth] = React.useState(0);

    const handleResize = React.useMemo(
        () =>
            throttle(() => {
                setWindowWidth(window.innerWidth);
            }, 100),
        [],
    );

    React.useEffect(() => {
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [handleResize]);

    // We return "desktop" on initial render to match the client behaviour to
    // server side rendering. This is required for SEO.
    return windowWidth === 0 || windowWidth >= DESKTOP_WIDTH
        ? "desktop"
        : "mobile";
}

export default useResponsiveLayout;
